var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.335 5.99707C13.0634 5.99707 13.6661 6.5921 13.6807 7.31738H17.0869C17.1988 7.31738 17.2855 7.37418 17.3418 7.44922C17.3971 7.52294 17.4257 7.61692 17.4258 7.7041C17.4258 7.8853 17.2766 8.06714 17.0635 8.06738H16.0059L15.4336 17.6445C15.4315 17.8517 15.2792 18.0028 15.0713 18.0029H8.92676C8.74674 18.0028 8.56686 17.8555 8.56445 17.6445L7.96777 8.04297H6.91113C6.81486 8.04297 6.72467 7.99604 6.66016 7.93164C6.59572 7.8672 6.54798 7.77691 6.54785 7.68066C6.54785 7.49934 6.69773 7.31738 6.91113 7.31738H10.3174C10.332 6.5921 10.9347 5.99707 11.6631 5.99707H12.335ZM9.28613 17.2529H14.7119L15.2793 8.06738H8.71875L9.28613 17.2529ZM11.6631 6.74707C11.3319 6.74707 11.0832 7.00866 11.0693 7.31738H12.9287C12.9146 6.9901 12.6468 6.74707 12.335 6.74707H11.6631Z",
    fill: "#F04438",
    stroke: "#F04438",
    strokeWidth: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.2b6e236a479f94dc178587fc51b0d7ae.svg";
export { ForwardRef as ReactComponent };